import Starring from "../../../../src/components/oh-deck/Starring";
import mengeMengeMenge from "../../../../src/images/mengeMengeMenge.png";
import * as React from 'react';
export default {
  Starring,
  mengeMengeMenge,
  React
};